// extracted by mini-css-extract-plugin
export var currencyInput = "_o5-1";
export var currencySymbol = "_o5-0";